import Header from "../../components/header/header";
import Footer from "../../components/footer";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { BackBtn } from "../../components/header/btn/back-btn";

function NotFound() {
  const navigate = useNavigate();
  const alertNoHomepage = () => {
    Swal.fire({
      title: '홈페이지가 아직 준비 중이에요!',
      text: '자세한 사항은 고객센터로 문의 바랍니다.',
      customClass: 'swal-alert',
      allowOutsideClick: false,
      showCancelButton: false,
      confirmButtonText: '확인',
      confirmButtonColor: '#2D2D2D'
    })
  }

  return (
    <div className="Layer not-found">
      <Header>
        <BackBtn onClick={() => navigate(-1)} />
      </Header>
      <div className="Layer-inner">
        <div className="contents-container">
          <div className="title-container">
            <h3>이런!<br />페이지를 불러올 수 없어요</h3>
          </div>
          <div className="desc-container">
            <p>잘못된 주소를 입력하셨거나, 요청하신 페이지의 주소가 변경되어 찾을 수 없습니다</p>
            <p className="gray-150">궁금한 점이 있으시다면 언제든 고객센터로 문의해주세요</p>
          </div>
        </div>
        <div className="primary-btn-container">
          <button className="btn primary" onClick={() => navigate(-1)}>이전 페이지로 이동</button>
          <button className="btn" onClick={alertNoHomepage}>홈으로 이동</button>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default NotFound;